import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { closeModal, openModal } from '../../../../../../redux/modals/action';
import Modal from '../../../../../layout/modal/Modal';
import styles from './FloorplanModal.module.scss';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import Lightbox from 'react-image-lightbox';
import { loadFloorplanImgs } from '../../../../../../redux/agreement/actions';

const FloorplanModal = ({
	openModal,
	closeModal,
	loadFloorplanImgs,
	floorplanImages,
	modelName,
	lotNumber,
	lotSizeType,
	lotSize,
	elevation,
}) => {
	const [floorplanUrls, setFloorplanUrls] = useState([]);
	const [hover, setHover] = useState('');
	const [openImage, setOpenImage] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);
	//
	useEffect(() => {
		console.log('floorplanImagesfloorplanImages', floorplanImages);
	}, [floorplanImages]);

	useEffect(() => {
		loadFloorplanImgs(modelName, elevation?.toLowerCase());
	}, [modelName, elevation]);

	const handleCloseModal = () => {
		console.log('I am closing this modal: handleCloseModal');
		openModal('reviewAps');
	};

	const styleHover = (id) => {
		if (Number(id) === Number(hover?.index)) {
			return { display: 'block' };
		}
	};

	return (
		<Modal show={openModal} close={handleCloseModal} includeClose={true}>
			<Grid container>
				<Grid item xs={4} className={styles.model_text}>
					<div className={styles.model_name}>{modelName}</div>
					<div className={styles.frontage_size}>
						{lotSizeType}" Lot
					</div>

					<div className={styles.main_texts}>
						<div className={styles.lot_num}>Lot {lotNumber}</div>
						<div className={styles.lot_num}>{lotSize} Sqft</div>
						{/* <div className={styles.lot_num}>4 Bedrooms</div> */}
						<div className={styles.lot_num}>
							Elevation {elevation}
						</div>
					</div>
				</Grid>
				<Grid item xs={8} className={styles.floorplanImages_container}>
					<div className={styles.content}>
						{floorplanImages?.length > 0 && (
							<>
								<Carousel
									autoPlay={false}
									className={styles.carousel}
									navButtonsAlwaysVisible={true}
									navButtonsProps={{
										style: {
											backgroundColor:
												'var(--primary-hover)',
										},
										className: 'navigation',
										'aria-label': 'button-wrapper',
									}}
									fullHeightHover
									navButtonsWrapperProps={{
										className: 'navButtonWrapper',
									}}
									activeIndicatorIconButtonProps={{
										style: {
											color: 'var(--primary-hover)',
										},
									}}
									indicatorIconButtonProps={{
										style: {
											color: 'var(--primary-label)',
										},
										'aria-label': 'indicator-icon',
									}}
								>
									{floorplanImages?.map((image, index) => {
										return (
											<div
												className={styles.floorplanItem}
												onMouseEnter={() =>
													setHover({
														...hover,
														index: index,
													})
												}
												onMouseLeave={() => setHover()}
												onClick={() => {
													setOpenImage(true);
													setPhotoIndex(index);
												}}
											>
												<img src={image} alt='test' />

												<div
													className={styles.layout}
													data-index={index}
													style={{
														...styleHover(index),
													}}
												></div>
												<div
													className={styles.zoomIcon}
												>
													<ZoomInIcon />
												</div>
											</div>
										);
									})}
								</Carousel>

								{openImage && (
									<Lightbox
										mainSrc={floorplanImages[photoIndex]}
										nextSrc={
											floorplanImages[
												(photoIndex + 1) %
													floorplanImages.length
											]
										}
										prevSrc={
											floorplanImages[
												(photoIndex +
													floorplanImages.length -
													1) %
													floorplanImages.length
											]
										}
										onCloseRequest={() =>
											setOpenImage(false)
										}
										onMovePrevRequest={() =>
											setPhotoIndex(
												(photoIndex +
													floorplanImages.length -
													1) %
													floorplanImages.length
											)
										}
										onMoveNextRequest={() =>
											setPhotoIndex(
												(photoIndex + 1) %
													floorplanImages.length
											)
										}
									/>
								)}
							</>
						)}
					</div>
				</Grid>
			</Grid>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	floorplanImages: state.agreement?.floorplansImages,
	modelName:
		state.agreement?.productAvailability?.modelName ||
		state.agreement?.agreementById?.productAvailability?.modelName,
	lotNumber:
		state.agreement?.productAvailability?.lotId ||
		state.agreement?.agreementById?.productAvailability?.lotId,
	lotSizeType:
		state.agreement?.productAvailability?.lotSizeType ||
		state.agreement?.agreementById?.productAvailability?.lotSizeType,
	lotSize:
		state.agreement?.productAvailability?.lotSize ||
		state.agreement?.agreementById?.productAvailability?.lotSize,
	elevation:
		state.agreement?.productAvailability?.elevation?.id ||
		state.agreement?.agreementById?.productAvailability?.elevation?.id,
});

export default connect(mapStateToProps, {
	closeModal,
	openModal,
	loadFloorplanImgs,
})(FloorplanModal);
